import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const FormObserver = () => {
  const formik = useFormikContext();

  useEffect(() => {
    const { errors, isSubmitting, isValid } = formik;
    const focusError = ({ errors, isValid, isSubmitting }) => {
      if (isSubmitting && !isValid && Object.keys(errors).length > 0 && document !== 'undefined') {
        const inputs = document.getElementsByName(Object.keys(errors)[0]);
        // Grabs element from modal when modal has same input as input on base page
        if (inputs.length > 1) {
          inputs[1].focus();
          return;
        }
        // Allows for selecting MUI Select
        if (inputs[0]?.['ariaHidden'] === 'true') {
          inputs[0]?.['previousSibling'].focus();
          return;
        } else {
          inputs[0]?.focus();
          return;
        }
      }
    };
    focusError({ errors, isSubmitting, isValid });
  }, [formik]);
  return null;
};

export default FormObserver;
